<template>
  <div>
    <h4 class="header" v-html="data.question" />
    <form>
      <template v-for="(response, i) in data.responses">
        <div class="ui field" :key="`response-${i}`">
          <div class="ui radio green checkbox" @click="changeRadio(i)">
            <input
              type="radio"
              name="radio"
              :value="answers[i]"
              :checked="answers[i]"
              :disabled="submitted" />
            <label>
              <span v-html="response.text" />
              <span
                class="ui green text"
                v-if="submitted && response.correct"
              >&nbsp;(Correct answer)</span>
            </label>
          </div>
        </div>
      </template>
    </form>
    <p class="disclaimer"><i>*Interactions are designed to help learning retention only. Interaction data is not stored for reporting.</i></p>
    <div v-if="submitted" :class="`ui ${ isCorrect ? 'success' : 'error' } message`">{{ messageText }}</div>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';

export default {
  name: 'MultipleChoice',
  props: ['id', 'type', 'data', 'standard'],
  data() {
    return {
      answers: [],
      submitted: false,
      isCorrect: null,
    };
  },
  computed: {
    messageText() {
      const i = this.answers.findIndex(a => a === true);
      return this.data.responses[i].feedback;
    },
  },
  methods: {
    changeRadio(index) {
      if (!this.submitted) {
        this.answers.forEach((a, i) => {
          this.answers[i] = (i === index);
        });
        this.$emit('valid', true);
      }
    },
    saveSCORMInteraction() {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: this.isCorrect,
        answer: this.answers,
        description: this.data.question,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
    submit() {
      let correct = true;
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i] !== this.data.responses[i].correct) {
          correct = false;
          break;
        }
      }
      this.isCorrect = correct;
      this.submitted = true;
      if (this.standard === 'SCORM_2004') {
        this.saveSCORMInteraction();
      }
      this.$emit('valid', false);
    },
  },
  mounted() {
    if (this.data.responses && this.data.responses.length > 0) {
      this.data.responses.forEach(response => {
        this.answers.push(false);
      });
    }
    $('.ui.multichoice.checkbox').checkbox();
  },
  watch: {
    'data.responses'(val, old) {
      this.answers = [];
      if (val && val.length > 0) {
        val.forEach(response => {
          this.answers.push(false);
        });
      }
    },
  },
};
</script>
